<template>
  <div class="review-content card-body p-2">
    <slot name="wizard" />

    <slot name="alert" />

    <div class="review-content__top-section-container">
      <div class="review-content__reason-transfer-container">
        <p class="review-content__reason-transfer-title">
          {{ $t('fleetTask.transferDeliveryModal.select.transferReason') }}
        </p>
        <div class="review-content__reason-transfer-value">
          {{ transferReasonFullObject?.reason }}
        </div>
      </div>

      <div
        v-if="hasSingleProductCategoryAccess && fleetTaskDetail?.product_category?.name"
        class="review-content__product-category-container"
      >
        <p class="review-content__product-category-title">
          {{ $t('fleetTask.transferDeliveryModal.deliveryOrderFields.productCategory') }}
        </p>
        <div class="review-content__product-category-value">
          {{ fleetTaskDetail?.product_category?.name }}
        </div>
      </div>
    </div>

    <hr />

    <div class="review-content__fleet-task-container">
      <FleetTaskSection
        :title="$t('fleetTask.transferDeliveryModal.review.originFleetTask')"
        :loading="isLoading"
        :fleetTask="fleetTaskDetail"
      />
      <div class="review-content__icon">
        <i class="icon-outline_arrow-right" />
      </div>
      <FleetTaskSection
        :title="$t('fleetTask.transferDeliveryModal.review.destinationFleetTask')"
        :loading="isLoading"
        :fleetTask="newFO"
      />
    </div>

    <DeliveryOrderSection
      v-if="isLoading == false"
      :title="$t('fleetTask.transferDeliveryModal.review.deliveryDetails')"
      :loading="isLoading"
      :deliveryOrderId="deliveryOrderId"
      :deliveryOrderIds="selectedOrderIds"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import FleetTaskSection from '../components/FleetTaskSection'
import DeliveryOrderSection from '../components/DeliveryOrderSection'

import * as FleetTask from '@/services/rest-api/lib/fleet-task/fleet-task'

export default {
  components: {
    FleetTaskSection,
    DeliveryOrderSection,
  },
  props: {
    selectedFOId: {
      type: String,
    },
    deliveryOrderId: {
      type: String,
      default: null
    },
    selectedOrderIds: {
      type: Object,
      default: () => {},
    },
    transferReasonFullObject: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
      newFO: {},
    }
  },
  computed: {
    ...mapState('fleetTask', ['fleetTaskDetail']),
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
    }),
    hasSingleProductCategoryAccess() {
      return this.hasAccessAll(['fleet-task-single-category-deliveries:read'])
    },
  },
  async mounted() {
    await this.showFOData()

    this.isLoading = false
  },
  methods: {
    async showFOData() {
      const res = await FleetTask.show(this.selectedFOId)

      if (res.errors && !res.data) return

      this.newFO = res.data
    },
  },
}
</script>

<style lang="scss" scoped>
.review-content {
  display: flex;
  flex-direction: column;
  gap: 8px;

  &__fleet-task-container {
    margin-bottom: 20px;
    display: flex;
    gap: 24px;
    justify-content: space-between;
    align-items: center;
  }

  &__icon {
    margin-top: 28px;
    i {
      font-size: 32px;

      &:before {
        color: #1c74da;
      }
    }
  }

  &__reason-transfer {
    &-title {
      font-size: 14px;
      color: $mep-color-text-300;
    }

    &-value {
      color: $mep-color-text-400;
    }
  }

  &__product-category {
    &-title {
      font-size: 14px;
      color: $mep-color-text-300;
    }

    &-value {
      color: $mep-color-text-400;
    }
  }

  &__top-section-container {
    display: flex;
    gap: 25px;
  }
}
</style>
